export const sidebarConstants = {
    VISIBILITY: 'SIDEBAR_VISIBILITY',
};